<!--
作者：Loong
时间：2020/11/10
-->
<!-- AccountDetails [ 账目明细 ] -->
<template>

    <div id='accountDetails' class="cash_list">
        <el-form :inline="true" :model="select" class="demo-form-inline" @keyup.enter.native="seach">
			<el-form-item label="类型">
				<el-select v-model="select.nature" placeholder="请选择" style="width: 150px;">
					<el-option v-for="item in natures" :key="item.num" :label="item.value" :value="item.num">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="支付方式">
				<el-select v-model="select.payType" placeholder="请选择" style="width: 150px;">
					<el-option v-for="item in payTypes" :key="item.num" :label="item.value" :value="item.num">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="创建时间">
				<el-date-picker v-model="select.startTime" type="date" placeholder="选择开始日期">
				</el-date-picker>
				<el-date-picker v-model="select.endTime" type="date" placeholder="选择结束日期">
				</el-date-picker>
			</el-form-item>
			<el-button type="primary" @click="seachCashList">查询</el-button>
			<el-button type="primary" @click="returnSearch">重置</el-button>
			<el-button type="primary" @click="downLoadList">导出</el-button>
			</el-form-item>
		</el-form>
		<div class="income">
			<span>账户民e购金额：<rt>{{recharge}}元</rt></span>
			<span>账户直充金额：<rt>{{directRecharge}}元</rt></span>
			<span>账户光大银行金额：<rt>{{guangda}}元</rt></span>
			<span>已提现金额：<rt style="color:red">{{hasTicketCost}}元</rt></span>
			<span>账户余额：<rt>{{account_money}}元</rt></span>
			<span>可提现金额：<rt style="color: green;">{{canTicketCost}}元</rt><rt style="color: red;">（不包含当日充值金额）</rt></span>
			
		</div>
			<span style="float: right;display: inline-block;margin-right: 50px;color: red;font-size: 14px;">支出：<rt>{{expenditure}}元</rt>,共{{expenditure_count}}笔</span>
			<span style="float: right;display: inline-block;margin-right: 20px;color: red;font-size: 14px;">收入：<rt>{{income}}元</rt>,共{{income_count}}笔</span>
		<el-table :data="meterList" border style="width:1652px;text-align:center;margin-bottom: 10px;font-size:12px;margin-top: 10px;" >
			</el-table-column>-->
			<el-table-column prop="create_time" label="创建时间" align="center" >
			</el-table-column>
			<el-table-column prop="flow_number" label="流水号" align="center" >
			</el-table-column>
			<el-table-column prop="order_code" label="订单号" align="center">
			</el-table-column>
			<el-table-column prop="account" label="户号"  align="center">
			</el-table-column>
			<el-table-column prop="meter_code" label="表号"  align="center">
			</el-table-column>
			<el-table-column prop="type" label="类型" align="center">
			</el-table-column>
			<el-table-column prop="pay_type" label="支付方式" align="center">
			</el-table-column>
			<el-table-column prop="total" label="收支金额（元）" align="center" color="green">
			</el-table-column>
			<el-table-column prop="rate" label="服务费率（%） " align="center">
			</el-table-column>
			<el-table-column prop="can_extract_cost" label="账户余额（元） " width="120 " align="center">
			</el-table-column>
		</el-table>
		<el-pagination @size-change="handleSizeChange " @current-change="handleCurrentChange " :page-size="pageSize " layout="total,prev, pager, next " :total="total ">
		</el-pagination>
    </div>

</template>

<script>
	import { mapState, mapGetters } from 'vuex'
	export default {
		name: 'service-list',
		data() {
			return {
				select:{
					startTime:'',
					endTime:'',
					nature:'',
					payType:''
				},
				directRecharge:'--',
				guangda: '--',
				hasTicketCost:'--',
				recharge:'--',
				account_money:'--',
				canTicketCost:'',
				income:'',
				income_count:'',
				expenditure:'',
				expenditure_count:'',
				prop:'',
				order:'',
				pageSize:15,
				total:0,
				page:0,
				meterList:[],
				color:'',
				natures:[
					{
						num:'1',
						value:'提现',
					},
					{
						num:'2',
						value:'充值',
					},
					{
						num:'4',
						value:'扣除服务费',
					},
					
				],
				payTypes:[
					{
						num:'1',
						value:'民e购',
					},
					{
						num:'2',
						value:'直充'
					},
					{
						num:'3',
						value:'光大银行'
					}
				],
			}
		},
		created:function(){
			this.seachCashList()
		},
		methods:{
			seachCashList(){
				this.$jssdk.property_lift.getAccountInfo({
					start_time:this.select.startTime,
					end_time:this.select.endTime,
					type:this.select.nature,
					pay_type:this.select.payType,
					is_export:'0',
				},(res) =>{
					this.meterList = res.data
					if(this.meterList.length == 0){
						this.$message({
							type:'info',
							message:'请求列表为空',
							duration:2000
						})
					}
					for(var i=0;i<this.meterList.length;i++){
						if(this.meterList[i].total<0){
							this.color = 'green'
							console.log(this.color)
						}
						console.log(this.meterList[i].total)
					}
					/*formatCurrency(res.income)*/
					this.total = res.total
					this.directRecharge = Number(res.direct_recharge).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
					this.guangda = Number(res.guangda).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
					this.canTicketCost =  Number(res.can_extract_cost).toFixed(4).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
					this.hasTicketCost =  Number(res.has_extract_cost).toFixed(4).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
					this.expenditure =  Number(res.expenditure).toFixed(4).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
					this.canExtract =  Number(res.can_extract_cost).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
					this.recharge =  Number(res.recharge).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
					this.account_money =  Number(res.account_money).toFixed(4).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
					this.expenditure =  Number(res.expenditure).toFixed(4).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
					this.expenditure_count = res.expenditure_count
					this.income =  Number(res.income).toFixed(4).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
					this.income_count = res.income_count
				},(err) =>{
					return this.$message({
						type:'warning',
						message:err.msg,
						duration:2000
					})
				})
			},
			returnSearch(){
				this.select.startTime = ''
				this.select.endTime = ''
				this.select.nature = ''
				this.select.payType = ''
			},
			handleSizeChange(val) {},
			handleCurrentChange(val) {
				this.page = val
				this.$jssdk.property_lift.getAccountInfo({
					start_time:this.select.startTime,
					end_time:this.select.endTime,
					type:this.select.nature,
					pay_type:this.select.payType,
					is_export:'0',
					page:val
				},(res) =>{
					this.meterList = res.data
				},(err) =>{
					return this.$message({
						type:'warning',
						message:err.msg,
						duration:2000
					})
				})
			},
			downLoadList(){
				this.$jssdk.property_lift.getAccountInfo({
					start_time:this.select.startTime,
					end_time:this.select.endTime,
					type:this.select.nature,
					pay_type:this.select.payType,
					is_export:'1',
					page:this.page
				},(res) =>{
					window.location.href = res.url
				},(err) =>{
					return this.$message({
						type:'warning',
						message:err.msg,
						duration:2000
					})
				})
			},
		}
	}
</script>

<style lang='less'>

</style>

<style lang='less' scoped>
    .income span{
		margin-right: 30px;
	}
</style>


// WEBPACK FOOTER //
// AccountDetails.vue?57f12663